import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e70a33f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "heatmap-name" }
const _hoisted_3 = { class: "legend-jet" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jet" }, null, -1))
const _hoisted_5 = {
  key: 0,
  id: "heatmap-loader"
}
const _hoisted_6 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.activeHeatmaps, (heatmap) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        id: "heatmaps-legend",
        class: "legend-container",
        key: heatmap.classification
      }, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.t("heatmaps.active")) + ": " + _toDisplayString(_ctx.t(
              `config.heatmap.${_ctx.state.currentSlide.tissueType}.${_ctx.state.currentSlide.stain}.${heatmap.classification}.displayText`
            )), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.getLowLabelFor(heatmap)), 1),
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString(_ctx.getHighLabelFor(heatmap)), 1)
        ], 512), [
          [_vShow, heatmap.config.showLegend !== false && !heatmap.config.isQuantificationLegend]
        ])
      ])), [
        [_vShow, !_ctx.isLoadingHeatmap && heatmap.isActive]
      ])
    }), 128)),
    (_ctx.isLoadingHeatmap)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.t("heatmapLoader.text")) + " ", 1),
          _createElementVNode("div", {
            class: "spinner",
            alt: _ctx.t('heatmapLoader.alt')
          }, null, 8, _hoisted_6)
        ]))
      : _createCommentVNode("", true)
  ]))
}